import { render, staticRenderFns } from "./NewOrderHasGaugeScans.vue?vue&type=template&id=27248336"
import script from "./NewOrderHasGaugeScans.vue?vue&type=script&lang=js"
export * from "./NewOrderHasGaugeScans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports